// import './registerServiceWorker'
import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Api from './modules/api/api'
import PortalVue from 'portal-vue'

// import 'element-theme-default'
import staticData from '@/staticData.js'

import ElementUI from 'element-ui'
import Formatters from '@/mixins/formatters.mixin.js'

import elementLocale from 'element-ui/lib/locale/lang/ru-RU'
// import './registerServiceWorker'
navigator.serviceWorker.getRegistrations().then(function (registrations) {
  for (const registration of registrations) {
    registration.unregister()
  }
})

Vue.use(ElementUI, { locale: elementLocale })
Vue.use(Api, store, router)
Vue.use(PortalVue)
Vue.prototype.$staticData = staticData

Vue.config.productionTip = false

new Vue({
  router,
  store,
  mixins: [Formatters],
  render: h => h(App)
}).$mount('#app')
